import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { EventService } from '../core/services/event.service';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AnalyticsService } from '../core/services/analytics.service';

@Component({
  selector: 'app-qr-redirect',
  template: `<p>Redirecting...</p>`,
})
export class QrRedirectComponent implements OnInit {
  hex: any;
  user: any;

  constructor(
    private route: ActivatedRoute,
    private eventService: EventService,
    private router: Router,
    private afAuth: AngularFireAuth,
    private http: HttpClient,
    private analytics: AnalyticsService
  ) {

    // Extract event ID from route parameters
    this.route.params.subscribe((params) => {
      this.hex = params['id'];
      if (this.hex) {
        localStorage.setItem('eventId', this.hex);
        localStorage.setItem('isEventId', 'true');
      }
    });
  }

  ngOnInit(): void {
    // Fire before checkUserAuthentication()'s redirect decision so a bounce
    // at login is still captured. No numeric event_id available at this
    // entry point (only the hex) — guest context registers later once the
    // user reaches event-detail's own data fetch.
    this.analytics.capture('invite_opened', {
      entry: 'qr_redirect',
      is_authenticated: localStorage.getItem('user') != null,
    });
    this.checkUserAuthentication();
  }

  private checkUserAuthentication(): void {
    this.collectMetadata(this.hex);
    // Check if the user is already authenticated
    this.afAuth.authState.subscribe((user) => {
      if (user) {
        // If the user is authenticated, redirect to selfie-redirect
        this.redirectToSelfie();
      } else {
        // If the user is not authenticated, redirect to login
        this.router.navigateByUrl('/auth/login', { replaceUrl: true });
      }
    });
  }

  private redirectToSelfie(): void {
    if (this.hex) {
      this.router.navigateByUrl(`/selfie-redirect/${this.hex}`);
    } else {
      this.router.navigateByUrl('/selfie-redirect');
    }
  }



  redirectToLogin(): void {
    localStorage.setItem('user', 'null');
    this.router.navigateByUrl('/auth/login', { replaceUrl: true });
  }

  async collectMetadata(qrCodeId: string): Promise<any> {
    const metadata: any = {
      timestamp: new Date().toISOString(),
      qrCodeId,
      userAgent: navigator.userAgent,
      referrer: document.referrer || 'direct',
    };

    try {
      const position = await this.getGeolocation();
      metadata.geolocation = {
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
      };
    } catch (error) {
      metadata.geolocation = 'Permission denied or not available';
    }

    return metadata;
  }

  getGeolocation(): Promise<GeolocationPosition> {
    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(resolve, reject);
      } else {
        reject('Geolocation not supported');
      }
    });
  }

  async saveScanMetadata(metadata: any): Promise<void> {
    // console.log(JSON.stringify(metadata) //__CONSOLE_LOG__);
    (await this.eventService.qrScanCount(JSON.stringify(metadata))).subscribe({
      next: (res: any) => {
        // console.log({ res }); //__CONSOLE_LOG__
      },
      error: (err) => {
        // console.error(err); //__CONSOLE_LOG__
      },
    });
  }
}
